import { render, staticRenderFns } from "./VideoInfoPage.vue?vue&type=template&id=62a880d0&scoped=true&"
import script from "./VideoInfoPage.vue?vue&type=script&lang=js&"
export * from "./VideoInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./VideoInfoPage.vue?vue&type=style&index=0&id=62a880d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a880d0",
  null
  
)

export default component.exports